// Standalone token holder so the API client can read the bearer token without importing the
// auth store (which would create a client ↔ store import cycle). The auth store keeps this in sync.
let token: string | null = null;

export const setApiToken = (t: string | null): void => {
  token = t;
};

export const getApiToken = (): string | null => token;

// The auth store registers a refresh handler here. On a 401 the client invokes it to silently
// renew the access token (and retry once); it resolves false when the session is unrecoverable.
// Decoupled via this registry so the client never imports the store (avoids an import cycle).
type RefreshHandler = () => Promise<boolean>;
let refreshHandler: RefreshHandler | null = null;

export const setRefreshHandler = (fn: RefreshHandler | null): void => {
  refreshHandler = fn;
};

export const getRefreshHandler = (): RefreshHandler | null => refreshHandler;
